// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressHeaderItem-module__font-s-10___aBAJ7 {
  font-size: 10px !important;
}

.ProgressHeaderItem-module__font-s-12___XqLii {
  font-size: 12px !important;
}

.ProgressHeaderItem-module__font-s-13___tBMRY {
  font-size: 13px !important;
}

.ProgressHeaderItem-module__font-s-14___DCF7D {
  font-size: 14px !important;
}

.ProgressHeaderItem-module__font-s-15___hCmdY {
  font-size: 15px !important;
}

.ProgressHeaderItem-module__font-s-16____pHtL {
  font-size: 16px !important;
}

.ProgressHeaderItem-module__font-s-18___vUqrF {
  font-size: 18px !important;
}

.ProgressHeaderItem-module__font-s-20___qVY_k {
  font-size: 20px !important;
}

.ProgressHeaderItem-module__font-s-22___RB2Gf {
  font-size: 22px !important;
}

.ProgressHeaderItem-module__font-s-28___dSecX {
  font-size: 28px !important;
}

.ProgressHeaderItem-module__font-w-400___U_5Ks {
  font-weight: 400 !important;
}

.ProgressHeaderItem-module__font-w-500___SlQ1v {
  font-weight: 500 !important;
}

.ProgressHeaderItem-module__font-w-600___gMq7_ {
  font-weight: 600 !important;
}

.ProgressHeaderItem-module__font-w-700___qxumW {
  font-weight: 700 !important;
}

.ProgressHeaderItem-module__p-5___wItPa {
  padding: 5px !important;
}

.ProgressHeaderItem-module__p-12___LZhoK {
  padding: 12px !important;
}

.ProgressHeaderItem-module__p-16___FgdHH {
  padding: 16px !important;
}

.ProgressHeaderItem-module__p-30___HAgDu {
  padding: 30px !important;
}

.ProgressHeaderItem-module__p-b-0___yqONo {
  padding-bottom: 0 !important;
}

.ProgressHeaderItem-module__p-b-5___IaNId {
  padding-bottom: 5px !important;
}

.ProgressHeaderItem-module__p-b-10___GlwA_ {
  padding-bottom: 10px !important;
}

.ProgressHeaderItem-module__p-b-12___vnBKQ {
  padding-bottom: 12px !important;
}

.ProgressHeaderItem-module__p-b-16___Ribwx {
  padding-bottom: 16px !important;
}

.ProgressHeaderItem-module__p-b-18___q6MTT {
  padding-bottom: 18px !important;
}

.ProgressHeaderItem-module__p-b-20___BPjTw {
  padding-bottom: 20px !important;
}

.ProgressHeaderItem-module__p-b-25___HwsIT {
  padding-bottom: 25px !important;
}

.ProgressHeaderItem-module__p-b-30___eOkXA {
  padding-bottom: 30px !important;
}

.ProgressHeaderItem-module__p-b-50___VSiQp {
  padding-bottom: 50px !important;
}

.ProgressHeaderItem-module__p-t-0___A2eWg {
  padding-top: 0 !important;
}

.ProgressHeaderItem-module__p-t-12___h1cHH {
  padding-top: 12px !important;
}

.ProgressHeaderItem-module__p-t-16___ySjg9 {
  padding-top: 16px !important;
}

.ProgressHeaderItem-module__p-t-18___Dvw7u {
  padding-top: 18px !important;
}

.ProgressHeaderItem-module__p-t-20___rQ8l3 {
  padding-top: 20px !important;
}

.ProgressHeaderItem-module__p-t-30___ttpAm {
  padding-top: 30px !important;
}

.ProgressHeaderItem-module__p-t-40___XcJU9 {
  padding-top: 40px !important;
}

.ProgressHeaderItem-module__p-t-50___evozT {
  padding-top: 50px !important;
}

.ProgressHeaderItem-module__p-l-20___Eg2f3 {
  padding-left: 20px !important;
}

.ProgressHeaderItem-module__p-l-30___z_vxd {
  padding-left: 30px !important;
}

.ProgressHeaderItem-module__p-l-40____0mDs {
  padding-left: 40px !important;
}

.ProgressHeaderItem-module__p-r-16___XTI_V {
  padding-right: 16px !important;
}

.ProgressHeaderItem-module__p-r-20___tcfPQ {
  padding-right: 20px !important;
}

.ProgressHeaderItem-module__p-r-30___V0Ybh {
  padding-right: 30px !important;
}

.ProgressHeaderItem-module__p-r-50___KpisR {
  padding-right: 50px !important;
}

.ProgressHeaderItem-module__p-r-60___LvJSL {
  padding-right: 60px !important;
}

.ProgressHeaderItem-module__m-b-1___uQqry {
  margin-bottom: 1px !important;
}

.ProgressHeaderItem-module__m-b-2___xG_h2 {
  margin-bottom: 2px !important;
}

.ProgressHeaderItem-module__m-b-6___cxHNh {
  margin-bottom: 6px !important;
}

.ProgressHeaderItem-module__m-b-8___kStPi {
  margin-bottom: 8px !important;
}

.ProgressHeaderItem-module__m-b-10___I7Dg9 {
  margin-bottom: 10px !important;
}

.ProgressHeaderItem-module__m-b-14___XpJFD {
  margin-bottom: 14px !important;
}

.ProgressHeaderItem-module__m-b-16___Pigib {
  margin-bottom: 16px !important;
}

.ProgressHeaderItem-module__m-b-20___NrUwI {
  margin-bottom: 20px !important;
}

.ProgressHeaderItem-module__m-b-22____2NIF {
  margin-bottom: 22px !important;
}

.ProgressHeaderItem-module__m-b-24___iOTYt {
  margin-bottom: 24px !important;
}

.ProgressHeaderItem-module__m-b-30___CcrPK {
  margin-bottom: 30px !important;
}

.ProgressHeaderItem-module__m-b-32___mBDQX {
  margin-bottom: 32px !important;
}

.ProgressHeaderItem-module__m-b-40___O3ICf {
  margin-bottom: 40px !important;
}

.ProgressHeaderItem-module__m-t-2___hsx_g {
  margin-top: 2px !important;
}

.ProgressHeaderItem-module__m-t-3___wfEzw {
  margin-top: 3px !important;
}

.ProgressHeaderItem-module__m-t-4___FmroU {
  margin-top: 4px !important;
}

.ProgressHeaderItem-module__m-t-5___z7MGz {
  margin-top: 5px !important;
}

.ProgressHeaderItem-module__m-t-8___ziMOk {
  margin-top: 8px !important;
}

.ProgressHeaderItem-module__m-t-10___Iiw74 {
  margin-top: 10px !important;
}

.ProgressHeaderItem-module__m-t-15___BTatD {
  margin-top: 15px !important;
}

.ProgressHeaderItem-module__m-t-16___RY9Es {
  margin-top: 16px !important;
}

.ProgressHeaderItem-module__m-t-20___aVIg2 {
  margin-top: 20px !important;
}

.ProgressHeaderItem-module__m-t-22___ZkBat {
  margin-top: 22px !important;
}

.ProgressHeaderItem-module__m-t-30____6HaS {
  margin-top: 30px !important;
}

.ProgressHeaderItem-module__m-t-32___lo_Yr {
  margin-top: 32px !important;
}

.ProgressHeaderItem-module__m-l-auto___lXndS {
  margin-left: auto !important;
}

.ProgressHeaderItem-module__m-l-4___j3o4R {
  margin-left: 4px !important;
}

.ProgressHeaderItem-module__m-l-5___ePBSw {
  margin-left: 5px !important;
}

.ProgressHeaderItem-module__m-l-6___UnSBf {
  margin-left: 6px !important;
}

.ProgressHeaderItem-module__m-l-8___ijJfC {
  margin-left: 8px !important;
}

.ProgressHeaderItem-module__m-l-10___llJ55 {
  margin-left: 10px !important;
}

.ProgressHeaderItem-module__m-l-16___hWpcX {
  margin-left: 16px !important;
}

.ProgressHeaderItem-module__m-l-20___QA0J_ {
  margin-left: 20px !important;
}

.ProgressHeaderItem-module__m-l-24___JgpgB {
  margin-left: 24px !important;
}

.ProgressHeaderItem-module__m-l-30___fbleK {
  margin-left: 30px !important;
}

.ProgressHeaderItem-module__m-l-35____s68w {
  margin-left: 35px !important;
}

.ProgressHeaderItem-module__m-l-40___hbbue {
  margin-left: 40px !important;
}

.ProgressHeaderItem-module__m-r-8___cLCN4 {
  margin-right: 8px !important;
}

.ProgressHeaderItem-module__m-r-10___BpwDF {
  margin-right: 10px !important;
}

.ProgressHeaderItem-module__m-r-16___iJI83 {
  margin-right: 16px !important;
}

.ProgressHeaderItem-module__m-r-20___eHkxt {
  margin-right: 20px !important;
}

.ProgressHeaderItem-module__m-r-24___VMq4m {
  margin-right: 24px !important;
}

.ProgressHeaderItem-module__m-r-30___oUIvZ {
  margin-right: 30px !important;
}

.ProgressHeaderItem-module__m-r-40___Nnj0w {
  margin-right: 40px !important;
}

.ProgressHeaderItem-module__border-r-3___gLvej {
  border-radius: 3px !important;
}

.ProgressHeaderItem-module__border-r-4___SE_eX {
  border-radius: 4px !important;
}

.ProgressHeaderItem-module__border-r-6___QwUIk {
  border-radius: 6px !important;
}

.ProgressHeaderItem-module__border-r-10___gwxxI {
  border-radius: 10px !important;
}

.ProgressHeaderItem-module__border-r-12___HSMJv {
  border-radius: 12px !important;
}

.ProgressHeaderItem-module__border-r-16___Sm5vm {
  border-radius: 16px !important;
}

.ProgressHeaderItem-module__border-r-50___m73Sx {
  border-radius: 50% !important;
}

.ProgressHeaderItem-module__primary-border___UWxtU {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ProgressHeaderItem-module__primary-border-b___IETJL {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ProgressHeaderItem-module__primary-border-t___E9oh_ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ProgressHeaderItem-module__primary-border-l___rdiXa {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ProgressHeaderItem-module__primary-border-r___fRYij {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ProgressHeaderItem-module__secondary-border___CApMW {
  border: 1px solid #637768;
}

.ProgressHeaderItem-module__secondary-border-b___GrwA4 {
  border-bottom: 1px solid #637768;
}

.ProgressHeaderItem-module__secondary-border-t___RpPNy {
  border-top: 1px solid #637768;
}

.ProgressHeaderItem-module__secondary-border-l___SkCHF {
  border-left: 1px solid #637768;
}

.ProgressHeaderItem-module__secondary-border-r____4ycQ {
  border-right: 1px solid #637768;
}

.ProgressHeaderItem-module__gap-0___FAhHp {
  gap: 0 !important;
}

.ProgressHeaderItem-module__gap-2___f1_Ko {
  gap: 2px !important;
}

.ProgressHeaderItem-module__gap-4___S9L3o {
  gap: 4px !important;
}

.ProgressHeaderItem-module__gap-5___ldUyK {
  gap: 5px !important;
}

.ProgressHeaderItem-module__gap-6___fv8m8 {
  gap: 6px !important;
}

.ProgressHeaderItem-module__gap-8___eTo_6 {
  gap: 8px !important;
}

.ProgressHeaderItem-module__gap-10____6Wvj {
  gap: 10px !important;
}

.ProgressHeaderItem-module__gap-12___HgTqO {
  gap: 12px !important;
}

.ProgressHeaderItem-module__gap-14___IfvhX {
  gap: 14px !important;
}

.ProgressHeaderItem-module__gap-16___AhGZL {
  gap: 16px !important;
}

.ProgressHeaderItem-module__gap-18___UqHo_ {
  gap: 18px !important;
}

.ProgressHeaderItem-module__gap-20___q2nxE {
  gap: 20px !important;
}

.ProgressHeaderItem-module__gap-24___sWTGu {
  gap: 24px !important;
}

.ProgressHeaderItem-module__gap-26___h6ull {
  gap: 26px !important;
}

.ProgressHeaderItem-module__gap-30___knzFB {
  gap: 30px !important;
}

.ProgressHeaderItem-module__gap-32___bKoWe {
  gap: 32px !important;
}

.ProgressHeaderItem-module__gap-40___NgDQ9 {
  gap: 40px !important;
}

.ProgressHeaderItem-module__gap-50___vSNiB {
  gap: 50px !important;
}

.ProgressHeaderItem-module__flex-1___PC2gv {
  flex: 1;
}

.ProgressHeaderItem-module__flex-none___FyHlo {
  flex: none !important;
}

.ProgressHeaderItem-module__flex-column___d2MPj {
  display: flex;
  flex-direction: column !important;
}

.ProgressHeaderItem-module__flex-row___r9myH {
  display: flex;
  flex-direction: row !important;
}

.ProgressHeaderItem-module__vertically-centered___oBrra {
  display: flex;
  align-items: center !important;
}

.ProgressHeaderItem-module__horizontally-centered___UVH3Q {
  display: flex;
  justify-content: center !important;
}

.ProgressHeaderItem-module__horizontally-end___hnHcN {
  display: flex;
  justify-content: end !important;
}

.ProgressHeaderItem-module__vertically-start___KZPp8 {
  display: flex;
  align-items: start !important;
}

.ProgressHeaderItem-module__space-between___vFr02 {
  display: flex;
  justify-content: space-between !important;
}

.ProgressHeaderItem-module__flex-wrap___NSu5J {
  flex-wrap: wrap !important;
}

.ProgressHeaderItem-module__height-100___GDLT4 {
  height: 100%;
}

.ProgressHeaderItem-module__width-50___KSJ_b {
  width: 50% !important;
}

.ProgressHeaderItem-module__width-100___w5pvf {
  width: 100%;
}

.ProgressHeaderItem-module__cursor-pointer___GqfKN {
  cursor: pointer;
}

.ProgressHeaderItem-module__cursor-not-allowed___jNBsU {
  cursor: not-allowed !important;
}

.ProgressHeaderItem-module__absolute-centered___Gqkh4 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ProgressHeaderItem-module__absolute___xQQxH {
  position: absolute;
}

.ProgressHeaderItem-module__relative___lAlME {
  position: relative;
}

.ProgressHeaderItem-module__fixed___DnYOg {
  position: fixed;
}

.ProgressHeaderItem-module__visible___EsqvD {
  opacity: 1;
}

.ProgressHeaderItem-module__invisible___zQdxD {
  opacity: 0;
}

.ProgressHeaderItem-module__col-90___C7qI_ {
  width: 90% !important;
}

.ProgressHeaderItem-module__col-auto___YWn_g {
  width: auto !important;
}

.ProgressHeaderItem-module__medical-tabs___VoLFp {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ProgressHeaderItem-module__medical-table-new___Bxh4E {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E::-webkit-scrollbar-track {
  display: none;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E.ProgressHeaderItem-module__no-pagination___oaD1K {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E.ProgressHeaderItem-module__no-pagination___oaD1K:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E.ProgressHeaderItem-module__no-pagination___oaD1K::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ProgressHeaderItem-module__medical-table-new___Bxh4E.ProgressHeaderItem-module__no-pagination___oaD1K::-webkit-scrollbar-track {
  display: none;
}

.ProgressHeaderItem-module__medical-table-empty___EMeKW {
  padding: 14px 40px !important;
}

.ProgressHeaderItem-module__icon-btn___bd4jl {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ProgressHeaderItem-module__search-icon___D6U9j {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ProgressHeaderItem-module__disable-select___RTsq3 {
  user-select: none;
}

.ProgressHeaderItem-module__break-word___JVKgT {
  word-break: break-word;
}

.ProgressHeaderItem-module__popup-clear-btn___XmiEi {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ProgressHeaderItem-module__scroll-m-b-20____fNkY {
  scroll-margin-bottom: 20px;
}

.ProgressHeaderItem-module__container___uPlEF {
  display: flex;
  height: 100px;
  padding: 12px 48px 12px 16px;
  background-color: #fdfcfa;
  border-radius: 12px;
  align-items: center;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__statusIcon___yupbP {
  width: 46px;
  height: 46px;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__textContainer___b69dr {
  padding: 4px 0;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__textContainer___b69dr .ProgressHeaderItem-module__header___fmqhP {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #a79988;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__textContainer___b69dr .ProgressHeaderItem-module__mainText___fGbg0 {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 19px;
  color: #375844;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__textContainer___b69dr .ProgressHeaderItem-module__supportingText___O3elw {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #637768;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__arrowBtn___KvNnW {
  width: 22px;
  height: 22px;
  cursor: pointer;
}
.ProgressHeaderItem-module__container___uPlEF .ProgressHeaderItem-module__arrowBtn___KvNnW.ProgressHeaderItem-module__disabled___GyrNM {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/ProgressHeaderItem/ProgressHeaderItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,aAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;AA3pBI;EEQF,+BApBO;EAqBP,gBAFmD;EFL/C,iBAAA;EACA,cAAA;AA8pBN;AA3pBI;EEEF,+BApBO;EAqBP,gBAFmD;EFC/C,iBAAA;EACA,cAAA;AA8pBN;AA3pBI;EEJF,+BApBO;EAqBP,gBAFmD;EFO/C,iBAAA;EACA,cAAA;AA8pBN;AA1pBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA4pBJ;AA1pBI;EACE,YAAA;EACA,mBAAA;AA4pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  height: 100px;\n  padding: 12px 48px 12px 16px;\n  background-color: get-color(grayNew, ultra-light);\n  border-radius: 12px;\n  align-items: center;\n\n  .statusIcon {\n    width: 46px;\n    height: 46px;\n  }\n\n  .textContainer {\n    padding: 4px 0;\n\n    .header {\n      @include get-font($roboto);\n      line-height: 150%;\n      color: #a79988;\n    }\n\n    .mainText {\n      @include get-font($roboto);\n      line-height: 19px;\n      color: get-color(greenNew, dark);\n    }\n\n    .supportingText {\n      @include get-font($roboto);\n      line-height: 150%;\n      color: get-color(greenNew, medium-dark);\n    }\n  }\n\n  .arrowBtn {\n    width: 22px;\n    height: 22px;\n    cursor: pointer;\n\n    &.disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ProgressHeaderItem-module__font-s-10___aBAJ7`,
	"fontS12": `ProgressHeaderItem-module__font-s-12___XqLii`,
	"fontS13": `ProgressHeaderItem-module__font-s-13___tBMRY`,
	"fontS14": `ProgressHeaderItem-module__font-s-14___DCF7D`,
	"fontS15": `ProgressHeaderItem-module__font-s-15___hCmdY`,
	"fontS16": `ProgressHeaderItem-module__font-s-16____pHtL`,
	"fontS18": `ProgressHeaderItem-module__font-s-18___vUqrF`,
	"fontS20": `ProgressHeaderItem-module__font-s-20___qVY_k`,
	"fontS22": `ProgressHeaderItem-module__font-s-22___RB2Gf`,
	"fontS28": `ProgressHeaderItem-module__font-s-28___dSecX`,
	"fontW400": `ProgressHeaderItem-module__font-w-400___U_5Ks`,
	"fontW500": `ProgressHeaderItem-module__font-w-500___SlQ1v`,
	"fontW600": `ProgressHeaderItem-module__font-w-600___gMq7_`,
	"fontW700": `ProgressHeaderItem-module__font-w-700___qxumW`,
	"p5": `ProgressHeaderItem-module__p-5___wItPa`,
	"p12": `ProgressHeaderItem-module__p-12___LZhoK`,
	"p16": `ProgressHeaderItem-module__p-16___FgdHH`,
	"p30": `ProgressHeaderItem-module__p-30___HAgDu`,
	"pB0": `ProgressHeaderItem-module__p-b-0___yqONo`,
	"pB5": `ProgressHeaderItem-module__p-b-5___IaNId`,
	"pB10": `ProgressHeaderItem-module__p-b-10___GlwA_`,
	"pB12": `ProgressHeaderItem-module__p-b-12___vnBKQ`,
	"pB16": `ProgressHeaderItem-module__p-b-16___Ribwx`,
	"pB18": `ProgressHeaderItem-module__p-b-18___q6MTT`,
	"pB20": `ProgressHeaderItem-module__p-b-20___BPjTw`,
	"pB25": `ProgressHeaderItem-module__p-b-25___HwsIT`,
	"pB30": `ProgressHeaderItem-module__p-b-30___eOkXA`,
	"pB50": `ProgressHeaderItem-module__p-b-50___VSiQp`,
	"pT0": `ProgressHeaderItem-module__p-t-0___A2eWg`,
	"pT12": `ProgressHeaderItem-module__p-t-12___h1cHH`,
	"pT16": `ProgressHeaderItem-module__p-t-16___ySjg9`,
	"pT18": `ProgressHeaderItem-module__p-t-18___Dvw7u`,
	"pT20": `ProgressHeaderItem-module__p-t-20___rQ8l3`,
	"pT30": `ProgressHeaderItem-module__p-t-30___ttpAm`,
	"pT40": `ProgressHeaderItem-module__p-t-40___XcJU9`,
	"pT50": `ProgressHeaderItem-module__p-t-50___evozT`,
	"pL20": `ProgressHeaderItem-module__p-l-20___Eg2f3`,
	"pL30": `ProgressHeaderItem-module__p-l-30___z_vxd`,
	"pL40": `ProgressHeaderItem-module__p-l-40____0mDs`,
	"pR16": `ProgressHeaderItem-module__p-r-16___XTI_V`,
	"pR20": `ProgressHeaderItem-module__p-r-20___tcfPQ`,
	"pR30": `ProgressHeaderItem-module__p-r-30___V0Ybh`,
	"pR50": `ProgressHeaderItem-module__p-r-50___KpisR`,
	"pR60": `ProgressHeaderItem-module__p-r-60___LvJSL`,
	"mB1": `ProgressHeaderItem-module__m-b-1___uQqry`,
	"mB2": `ProgressHeaderItem-module__m-b-2___xG_h2`,
	"mB6": `ProgressHeaderItem-module__m-b-6___cxHNh`,
	"mB8": `ProgressHeaderItem-module__m-b-8___kStPi`,
	"mB10": `ProgressHeaderItem-module__m-b-10___I7Dg9`,
	"mB14": `ProgressHeaderItem-module__m-b-14___XpJFD`,
	"mB16": `ProgressHeaderItem-module__m-b-16___Pigib`,
	"mB20": `ProgressHeaderItem-module__m-b-20___NrUwI`,
	"mB22": `ProgressHeaderItem-module__m-b-22____2NIF`,
	"mB24": `ProgressHeaderItem-module__m-b-24___iOTYt`,
	"mB30": `ProgressHeaderItem-module__m-b-30___CcrPK`,
	"mB32": `ProgressHeaderItem-module__m-b-32___mBDQX`,
	"mB40": `ProgressHeaderItem-module__m-b-40___O3ICf`,
	"mT2": `ProgressHeaderItem-module__m-t-2___hsx_g`,
	"mT3": `ProgressHeaderItem-module__m-t-3___wfEzw`,
	"mT4": `ProgressHeaderItem-module__m-t-4___FmroU`,
	"mT5": `ProgressHeaderItem-module__m-t-5___z7MGz`,
	"mT8": `ProgressHeaderItem-module__m-t-8___ziMOk`,
	"mT10": `ProgressHeaderItem-module__m-t-10___Iiw74`,
	"mT15": `ProgressHeaderItem-module__m-t-15___BTatD`,
	"mT16": `ProgressHeaderItem-module__m-t-16___RY9Es`,
	"mT20": `ProgressHeaderItem-module__m-t-20___aVIg2`,
	"mT22": `ProgressHeaderItem-module__m-t-22___ZkBat`,
	"mT30": `ProgressHeaderItem-module__m-t-30____6HaS`,
	"mT32": `ProgressHeaderItem-module__m-t-32___lo_Yr`,
	"mLAuto": `ProgressHeaderItem-module__m-l-auto___lXndS`,
	"mL4": `ProgressHeaderItem-module__m-l-4___j3o4R`,
	"mL5": `ProgressHeaderItem-module__m-l-5___ePBSw`,
	"mL6": `ProgressHeaderItem-module__m-l-6___UnSBf`,
	"mL8": `ProgressHeaderItem-module__m-l-8___ijJfC`,
	"mL10": `ProgressHeaderItem-module__m-l-10___llJ55`,
	"mL16": `ProgressHeaderItem-module__m-l-16___hWpcX`,
	"mL20": `ProgressHeaderItem-module__m-l-20___QA0J_`,
	"mL24": `ProgressHeaderItem-module__m-l-24___JgpgB`,
	"mL30": `ProgressHeaderItem-module__m-l-30___fbleK`,
	"mL35": `ProgressHeaderItem-module__m-l-35____s68w`,
	"mL40": `ProgressHeaderItem-module__m-l-40___hbbue`,
	"mR8": `ProgressHeaderItem-module__m-r-8___cLCN4`,
	"mR10": `ProgressHeaderItem-module__m-r-10___BpwDF`,
	"mR16": `ProgressHeaderItem-module__m-r-16___iJI83`,
	"mR20": `ProgressHeaderItem-module__m-r-20___eHkxt`,
	"mR24": `ProgressHeaderItem-module__m-r-24___VMq4m`,
	"mR30": `ProgressHeaderItem-module__m-r-30___oUIvZ`,
	"mR40": `ProgressHeaderItem-module__m-r-40___Nnj0w`,
	"borderR3": `ProgressHeaderItem-module__border-r-3___gLvej`,
	"borderR4": `ProgressHeaderItem-module__border-r-4___SE_eX`,
	"borderR6": `ProgressHeaderItem-module__border-r-6___QwUIk`,
	"borderR10": `ProgressHeaderItem-module__border-r-10___gwxxI`,
	"borderR12": `ProgressHeaderItem-module__border-r-12___HSMJv`,
	"borderR16": `ProgressHeaderItem-module__border-r-16___Sm5vm`,
	"borderR50": `ProgressHeaderItem-module__border-r-50___m73Sx`,
	"primaryBorder": `ProgressHeaderItem-module__primary-border___UWxtU`,
	"primaryBorderB": `ProgressHeaderItem-module__primary-border-b___IETJL`,
	"primaryBorderT": `ProgressHeaderItem-module__primary-border-t___E9oh_`,
	"primaryBorderL": `ProgressHeaderItem-module__primary-border-l___rdiXa`,
	"primaryBorderR": `ProgressHeaderItem-module__primary-border-r___fRYij`,
	"secondaryBorder": `ProgressHeaderItem-module__secondary-border___CApMW`,
	"secondaryBorderB": `ProgressHeaderItem-module__secondary-border-b___GrwA4`,
	"secondaryBorderT": `ProgressHeaderItem-module__secondary-border-t___RpPNy`,
	"secondaryBorderL": `ProgressHeaderItem-module__secondary-border-l___SkCHF`,
	"secondaryBorderR": `ProgressHeaderItem-module__secondary-border-r____4ycQ`,
	"gap0": `ProgressHeaderItem-module__gap-0___FAhHp`,
	"gap2": `ProgressHeaderItem-module__gap-2___f1_Ko`,
	"gap4": `ProgressHeaderItem-module__gap-4___S9L3o`,
	"gap5": `ProgressHeaderItem-module__gap-5___ldUyK`,
	"gap6": `ProgressHeaderItem-module__gap-6___fv8m8`,
	"gap8": `ProgressHeaderItem-module__gap-8___eTo_6`,
	"gap10": `ProgressHeaderItem-module__gap-10____6Wvj`,
	"gap12": `ProgressHeaderItem-module__gap-12___HgTqO`,
	"gap14": `ProgressHeaderItem-module__gap-14___IfvhX`,
	"gap16": `ProgressHeaderItem-module__gap-16___AhGZL`,
	"gap18": `ProgressHeaderItem-module__gap-18___UqHo_`,
	"gap20": `ProgressHeaderItem-module__gap-20___q2nxE`,
	"gap24": `ProgressHeaderItem-module__gap-24___sWTGu`,
	"gap26": `ProgressHeaderItem-module__gap-26___h6ull`,
	"gap30": `ProgressHeaderItem-module__gap-30___knzFB`,
	"gap32": `ProgressHeaderItem-module__gap-32___bKoWe`,
	"gap40": `ProgressHeaderItem-module__gap-40___NgDQ9`,
	"gap50": `ProgressHeaderItem-module__gap-50___vSNiB`,
	"flex1": `ProgressHeaderItem-module__flex-1___PC2gv`,
	"flexNone": `ProgressHeaderItem-module__flex-none___FyHlo`,
	"flexColumn": `ProgressHeaderItem-module__flex-column___d2MPj`,
	"flexRow": `ProgressHeaderItem-module__flex-row___r9myH`,
	"verticallyCentered": `ProgressHeaderItem-module__vertically-centered___oBrra`,
	"horizontallyCentered": `ProgressHeaderItem-module__horizontally-centered___UVH3Q`,
	"horizontallyEnd": `ProgressHeaderItem-module__horizontally-end___hnHcN`,
	"verticallyStart": `ProgressHeaderItem-module__vertically-start___KZPp8`,
	"spaceBetween": `ProgressHeaderItem-module__space-between___vFr02`,
	"flexWrap": `ProgressHeaderItem-module__flex-wrap___NSu5J`,
	"height100": `ProgressHeaderItem-module__height-100___GDLT4`,
	"width50": `ProgressHeaderItem-module__width-50___KSJ_b`,
	"width100": `ProgressHeaderItem-module__width-100___w5pvf`,
	"cursorPointer": `ProgressHeaderItem-module__cursor-pointer___GqfKN`,
	"cursorNotAllowed": `ProgressHeaderItem-module__cursor-not-allowed___jNBsU`,
	"absoluteCentered": `ProgressHeaderItem-module__absolute-centered___Gqkh4`,
	"absolute": `ProgressHeaderItem-module__absolute___xQQxH`,
	"relative": `ProgressHeaderItem-module__relative___lAlME`,
	"fixed": `ProgressHeaderItem-module__fixed___DnYOg`,
	"visible": `ProgressHeaderItem-module__visible___EsqvD`,
	"invisible": `ProgressHeaderItem-module__invisible___zQdxD`,
	"col90": `ProgressHeaderItem-module__col-90___C7qI_`,
	"colAuto": `ProgressHeaderItem-module__col-auto___YWn_g`,
	"medicalTabs": `ProgressHeaderItem-module__medical-tabs___VoLFp`,
	"medicalTableNew": `ProgressHeaderItem-module__medical-table-new___Bxh4E`,
	"noPagination": `ProgressHeaderItem-module__no-pagination___oaD1K`,
	"medicalTableEmpty": `ProgressHeaderItem-module__medical-table-empty___EMeKW`,
	"iconBtn": `ProgressHeaderItem-module__icon-btn___bd4jl`,
	"searchIcon": `ProgressHeaderItem-module__search-icon___D6U9j`,
	"disableSelect": `ProgressHeaderItem-module__disable-select___RTsq3`,
	"breakWord": `ProgressHeaderItem-module__break-word___JVKgT`,
	"popupClearBtn": `ProgressHeaderItem-module__popup-clear-btn___XmiEi`,
	"scrollMB20": `ProgressHeaderItem-module__scroll-m-b-20____fNkY`,
	"container": `ProgressHeaderItem-module__container___uPlEF`,
	"statusIcon": `ProgressHeaderItem-module__statusIcon___yupbP`,
	"textContainer": `ProgressHeaderItem-module__textContainer___b69dr`,
	"header": `ProgressHeaderItem-module__header___fmqhP`,
	"mainText": `ProgressHeaderItem-module__mainText___fGbg0`,
	"supportingText": `ProgressHeaderItem-module__supportingText___O3elw`,
	"arrowBtn": `ProgressHeaderItem-module__arrowBtn___KvNnW`,
	"disabled": `ProgressHeaderItem-module__disabled___GyrNM`
};
module.exports = ___CSS_LOADER_EXPORT___;
